/** Campos padrão do formulário TR (configuráveis por fluxo). Persistidos no servidor. */
export const CAMPOS_TR_PADRAO = [
  {
    id: 'campo-objeto',
    chave: 'objeto',
    label: 'Objeto',
    tipo: 'textarea',
    obrigatorio: true,
    ordem: 1,
  },
  {
    id: 'campo-justificativa',
    chave: 'justificativa',
    label: 'Justificativa da contratação',
    tipo: 'textarea',
    obrigatorio: false,
    ordem: 2,
  },
  {
    id: 'campo-descricao',
    chave: 'descricaoMinuciosa',
    label: 'Descrição minuciosa do serviço',
    tipo: 'textarea',
    obrigatorio: false,
    ordem: 3,
  },
  {
    id: 'campo-prazo',
    chave: 'prazoExecucao',
    label: 'Prazo de execução',
    tipo: 'texto',
    obrigatorio: false,
    ordem: 4,
  },
  {
    id: 'campo-valor',
    chave: 'valorEstimado',
    label: 'Valor estimado (R$)',
    tipo: 'numero',
    obrigatorio: false,
    ordem: 5,
  },
];

export const TIPOS_CAMPO_TR = [
  { value: 'texto', label: 'Texto curto' },
  { value: 'textarea', label: 'Texto longo' },
  { value: 'numero', label: 'Número' },
  { value: 'data', label: 'Data' },
];

export function normalizarCamposTr(raw) {
  let lista = [];
  if (typeof raw === 'string' && raw.trim()) {
    try {
      lista = JSON.parse(raw);
    } catch {
      lista = [];
    }
  } else if (Array.isArray(raw)) {
    lista = raw;
  }
  if (!lista.length) return CAMPOS_TR_PADRAO.map((c) => ({ ...c }));
  return lista
    .map((c, i) => ({
      id: c.id || `campo-${i}-${c.chave || i}`,
      chave: String(c.chave || `campo_${i + 1}`)
        .trim()
        .replace(/\s+/g, '_')
        .toLowerCase(),
      label: String(c.label || c.chave || `Campo ${i + 1}`),
      tipo: ['texto', 'textarea', 'numero', 'data'].includes(c.tipo) ? c.tipo : 'texto',
      obrigatorio: !!c.obrigatorio,
      ordem: Number(c.ordem) || i + 1,
    }))
    .sort((a, b) => a.ordem - b.ordem);
}

export function novoCampoTr(ordem = 1) {
  const n = Date.now();
  return {
    id: `campo-${n}`,
    chave: `campo_${ordem}`,
    label: `Novo campo ${ordem}`,
    tipo: 'texto',
    obrigatorio: false,
    ordem,
  };
}
